import { gql } from "@apollo/client";

export const MY_NOTIFICATIONS = gql`
  query MyNotificationsQuery($where: MyNotificationsFiltersInput) {
    myNotifications(where: $where) {
      ok
      error
      total
      unreadCount
      results {
        id
        title
        content
        table
        objectId
        read
        createdAt
      }
    }
  }
`;

export const NOTIFICATION = gql`
  query NotificationQuery($id: Int!) {
    notification(id: $id) {
      ok
      error
      result {
        id
        title
        content
        table
        objectId
        read
        createdAt
      }
    }
  }
`;

export const MARK_NOTIFICATIONS_AS_READ = gql`
  mutation MarkNotificationsAsReadMutation($ids: [Int!]!) {
    markNotificationsAsRead(ids: $ids) {
      ok
      error
      updatedCount
    }
  }
`;

export const MARK_ALL_NOTIFICATIONS_AS_READ = gql`
  mutation MarkAllNotificationsAsReadMutation {
    markAllNotificationsAsRead {
      ok
      error
      updatedCount
    }
  }
`;

export const REMOVE_NOTIFICATION = gql`
  mutation RemoveNotificationMutation($id: Int!) {
    removeNotification(id: $id) {
      ok
      error
    }
  }
`;
